/**
 * Set logflag when user loggedIn in Application
 * SetCookie when remMe is selected and Remove cookie when user is logOut
 */
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import {
  LocalStorageService,
  SessionStorageService,
} from 'angular-web-storage';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  currentDate: Date | undefined;
  public loggedIn: any;

  constructor(
    private cookieService: CookieService,
    public session: SessionStorageService,
    public storage: LocalStorageService
  ) {}

  // loggedIn variable store true that indicate any user is logged in.
  SetLogFlag(): void {
    this.loggedIn = true;
    this.storage.set('loggedIn', this.loggedIn);
  }

  // get loggedIn flag stored in session.
  getLogflag(): string {
    return this.storage.get('loggedIn');
  }

  // removeLogFlag is deleted from cookies on clicking of logOut button
  removeLogFlag(): void {
    this.storage.set('loggedIn', '');
  }

  // set UserDTO stored in session.
  setSessionData(data: any) {
    this.storage.set('userDTO', data);
  }

  // sets cookie for 7 days.
  setCookie(data: any, token: string): void {
    this.currentDate = new Date();
    // to add 7 days to current date
    this.currentDate.setDate(this.currentDate.getDate() + 7);
    this.cookieService.set('keekuUser', 'true', this.currentDate, '/');
    this.cookieService.set(
      'logUserDetails',
      JSON.stringify(data),
      this.currentDate,
      '/'
    );
    this.cookieService.set('logToken', token, this.currentDate, '/');
  }

  // removes a stored cookie.
  removeCookie(): void {
    this.cookieService.delete('keekuUser', '/');
    this.cookieService.delete('logUserDetails', '/');
    this.cookieService.delete('logToken', '/');
    this.session.clear();
    this.storage.clear();
  }

  // getting a user stored in session.
  getUser(): any {
    return this.storage.get('userDTO');
  }

  getToken() {
    return this.storage.get('token');
  }

  setToken(token: String) {
    this.storage.set('token', token);
  }

  // set UserDTO stored in session.
  setUserDetails(data: any) {
    this.storage.set('user', data);
  }

  // getting a user stored in session.
  getUserDetails(): any {
    return this.storage.get('user');
  }

  // set represenatative data
  setRepresentativeList(data: any) {
    this.storage.set('representativeList', data);
  }

  // get representative data
  getRepresentativeList(): any {
    return this.storage.get('representativeList');
  }

  // set eventDTO stored in session.
  setEventDetails(data: any) {
    this.storage.set('eventDTO', data);
  }

  // getting a eventDTO stored in session.
  getEventDetails(): any {
    return this.storage.get('eventDTO');
  }

  setProfileName(name: string) {
    this.storage.set('profileName', name);
  }

  getProfileName() {
    return this.storage.get('profileName');
  }

  createPoliticiansPage(data: boolean) {
    this.storage.set('politicianPage', data);
  }

  getPoliticiansPage() {
    return this.storage.get('politicianPage');
  }
}
